import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { useAuth } from "../stores/auth";
import { useActiveCompany } from "../stores/active-company";
import type { Company } from "../components/admin/shared";
import { AuditLogSection } from "../components/admin/activity";

export const Route = createFileRoute("/admin/activity")({
  component: AdminActivityPage,
});

function AdminActivityPage() {
  const user = useAuth((s) => s.user);
  const activeCompanyId = useActiveCompany((s) => s.activeCompanyId);
  // Deduped with the layout's identical query — only used for the header label.
  const companiesQ = useQuery({
    queryKey: ["admin", "companies"],
    enabled: user?.role === "global_admin",
    queryFn: () => api<{ companies: Company[] }>("/admin/companies"),
  });
  if (!user) return null;
  const isGlobal = user.role === "global_admin";
  const activeCompany =
    companiesQ.data?.companies.find((c) => c.id === activeCompanyId) ?? null;
  return (
    <AuditLogSection
      isGlobalAdmin={isGlobal}
      activeCompanyId={isGlobal ? activeCompanyId : user.companyId}
      activeCompanyName={isGlobal ? activeCompany?.name ?? null : user.companyName}
    />
  );
}
